var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ContentMixin_Store_DetailSourceCopy)?_c('base-steps-view',{attrs:{"default-step-on-select":_vm.DefaultStep,"steps":_vm.Steps}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }